// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-header[data-v-68975faa] {\n  margin-bottom: 0;\n  border-bottom: 1px solid;\n  background-color: rgb(228, 228, 228);\n  border-color: #d8dbe0;\n  color: #000 !important;\n}", ""]);
// Exports
module.exports = exports;
